// extracted by mini-css-extract-plugin
module.exports = {"vignette":"Vignette-module_vignette__1Qs10"};